module.exports = __webpack_public_path__ + "media/images/lp/lp25-14748789a8bfa11347e8e563dee8c8ea.webp";